import { render, staticRenderFns } from "./CadastroTroncos.vue?vue&type=template&id=628b511f&scoped=true&"
import script from "./CadastroTroncos.vue?vue&type=script&lang=js&"
export * from "./CadastroTroncos.vue?vue&type=script&lang=js&"
import style0 from "./CadastroTroncos.vue?vue&type=style&index=0&id=628b511f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628b511f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
